import * as echarts from 'echarts';
import { VariableType } from '../../../../types/dashboard.types';
import { VariableConfig, TooltipOrderMode } from '../types';
import { getTooltipPrecision } from './valueFormatting';

// Utility function to create tooltip configuration
export const createTooltipConfig = (
  selectedVariable: VariableType,
  currentConfig: VariableConfig,
  isDark: boolean,
  tooltipOrderMode: TooltipOrderMode = 'value',
  timezone?: string,
  formatInUserTimezone?: (timestamp: string, format: string) => string,
): echarts.TooltipComponentOption => {
  return {
    trigger: 'axis',
    appendToBody: true,
    z: 9999,
    formatter: (params: any) => {
      if (!params || params.length === 0) return '';

      // Format time following forecast page pattern
      const time =
        timezone === 'UTC'
          ? new Date(params[0].value[0]).toLocaleString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              month: 'short',
              day: 'numeric',
              timeZone: 'UTC',
              timeZoneName: 'short',
            })
          : formatInUserTimezone
            ? formatInUserTimezone(new Date(params[0].value[0]).toISOString(), 'MMM d, HH:mm zzz')
            : new Date(params[0].value[0]).toLocaleString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                month: 'short',
                day: 'numeric',
              });

      let result = `<div style="font-size: 12px; font-weight: 500; margin-bottom: 8px;">${time}</div>`;

      // Filter valid params
      const validParams = params.filter(
        (param: any) => param.value[1] !== null && param.value[1] !== undefined,
      );

      let sortedParams: any[];

      if (tooltipOrderMode === 'value') {
        // Sort by value with Mean always first
        const meanParam = validParams.find((param: any) => param.seriesName === 'Mean');
        const otherParams = validParams.filter((param: any) => param.seriesName !== 'Mean');

        // Sort other models by value in descending order (highest to lowest)
        const sortedOtherParams = otherParams.sort(
          (a: any, b: any) => Number(b.value[1]) - Number(a.value[1]),
        );

        // Combine with Mean first, then sorted other models
        sortedParams = meanParam ? [meanParam, ...sortedOtherParams] : sortedOtherParams;
      } else {
        // Fixed order - use original order from chart
        sortedParams = validParams;
      }

      sortedParams.forEach((param: any) => {
        const precision = getTooltipPrecision(param.value[1], selectedVariable);
        result += `<div style="font-size: 12px; color: ${param.color}">
          ${param.seriesName}: ${Number(param.value[1]).toFixed(precision)} ${currentConfig.unit}
        </div>`;
      });
      return result;
    },
    backgroundColor: isDark ? '#374151' : '#FFFFFF',
    borderColor: isDark ? '#6B7280' : '#E5E7EB',
    borderWidth: 1,
    textStyle: {
      color: isDark ? '#F3F4F6' : '#111827',
    },
  };
};
